import { AfterViewInit, Component, ElementRef, Inject, OnDestroy, Renderer2 } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { BaseDialog } from '../base.dialog';
import { ClientNotificationInterface } from '../../../../core';
import { ParentEvents } from '../../../utils/parent-events.service';

@Component({
    templateUrl: './validation-notifications.dialog.html',
    styleUrls: ['./validation-notifications.dialog.scss'],
})
export class ValidationNotificationsDialog extends BaseDialog implements AfterViewInit, OnDestroy {
    constructor(
        el: ElementRef,
        parentEvents: ParentEvents,
        renderer: Renderer2,
        private dialogRef: MatDialogRef<ValidationNotificationsDialog>,
        @Inject(MAT_DIALOG_DATA) public data: ClientNotificationInterface[]
    ) {
        super(parentEvents, el, renderer);
    }

    onClose() {
        this.dialogRef.close(false);
    }
}
